export type ThemePreference = "system" | "light" | "dark";
export type AccentProfile = "blue" | "red";
export const themeStorageKey = "insights-theme";

export function normalizeThemePreference(
  value: string | null,
): ThemePreference {
  return value === "light" || value === "dark" ? value : "system";
}

export function resolveTheme(
  preference: ThemePreference,
  systemDark: boolean,
): "light" | "dark" {
  return preference === "system" ? (systemDark ? "dark" : "light") : preference;
}

export function applyTheme(preference: ThemePreference) {
  const media = window.matchMedia("(prefers-color-scheme: dark)");
  const resolved = resolveTheme(preference, media.matches);
  if (preference === "system") {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.dataset.theme = preference;
  }
  document.documentElement.style.colorScheme = resolved;
  const red = document.documentElement.dataset.accent === "red";
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute(
      "content",
      resolved === "dark"
        ? red
          ? "#160b12"
          : "#07101f"
        : red
          ? "#fff8fa"
          : "#f5f8ff",
    );
  localStorage.setItem(themeStorageKey, preference);
}

export function applyAccent(accent: AccentProfile) {
  if (accent === "blue") {
    document.documentElement.removeAttribute("data-accent");
  } else {
    document.documentElement.dataset.accent = accent;
  }
}

export function initializeTheme(accent: AccentProfile = "blue") {
  applyAccent(accent);
  applyTheme(normalizeThemePreference(localStorage.getItem(themeStorageKey)));
}
